










import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";
import Tag from "@/components/miscellaneous/Tag.vue";

interface Insertion {
    status: string;
}

const components = {
    SimpleText,
    Tag,
};

@Component({ components })
export default class Status extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "insertion.status"
        ];
    }
}
